
<mat-tab-group> 
  <mat-tab  label = "Dinamico"> Contenido 1 </mat-tab> 
  <mat-tab  label = "Estatico"> Contenido 2 </mat-tab> 
</mat-tab-group>

